export default __webpack_public_path__ + "static/assets/med_pill_round_out_L1_solid_l_01_f_mask.437fd4b1.png";